import { queryOptions, useQuery } from '@tanstack/react-query';
import { ApiError } from '../../components/ApiLoadingGuard/ApiLoadingGuard';
import { BillableMaterial } from '../../components/BillableMaterials/types';
import { BillableMaterialsService } from '../generated';
import { toBillableMaterial } from '../../components/BillableMaterials/billableMaterial.helper';

export const billableMaterialsKeys = {
  base: () => ['billableMaterials'] as const,
  read: ({ organisationId }: BillableMaterialsOptionProps) =>
    [...billableMaterialsKeys.base(), organisationId] as const,
};

export interface BillableMaterialsOptionProps {
  organisationId: string;
}

export function billableMaterialsOptions({ organisationId }: BillableMaterialsOptionProps) {
  return queryOptions<BillableMaterial[], ApiError>({
    queryKey: billableMaterialsKeys.read({ organisationId }),
    queryFn: async (): Promise<BillableMaterial[]> => {
      const response = await BillableMaterialsService.billableMaterialControllerGetBillableMaterials({
        path: {
          organisationId,
        },
      });

      if (response.data !== undefined) {
        return response.data.map(toBillableMaterial);
      } else {
        throw (response as any).error || new Error(response?.response?.statusText || 'Unknown error');
      }
    },
    enabled: !!organisationId,
  });
}

export function useBillableMaterials(props: BillableMaterialsOptionProps) {
  return useQuery(billableMaterialsOptions(props));
}
